/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  BootstrapResponseData
} from '../../model/bootstrapResponseData'
import type {
  PingResponseData
} from '../../model/pingResponseData'
import type {
  UnusedModelsData
} from '../../model/unusedModelsData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * API endpoint used by frontend to initialize the app.
 */
export const bootstrap = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<BootstrapResponseData>(
      {url: `/frontend/bootstrap`, method: 'GET', signal
    },
      options);
    }
  

export const getBootstrapQueryKey = () => {
    return [`/frontend/bootstrap`] as const;
    }

    
export const getBootstrapQueryOptions = <TData = Awaited<ReturnType<typeof bootstrap>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bootstrap>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBootstrapQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bootstrap>>> = ({ signal }) => bootstrap(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bootstrap>>, TError, TData> & { queryKey: QueryKey }
}

export type BootstrapQueryResult = NonNullable<Awaited<ReturnType<typeof bootstrap>>>
export type BootstrapQueryError = unknown

export const useBootstrap = <TData = Awaited<ReturnType<typeof bootstrap>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bootstrap>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBootstrapQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getBootstrapSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof bootstrap>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bootstrap>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBootstrapQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bootstrap>>> = ({ signal }) => bootstrap(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof bootstrap>>, TError, TData> & { queryKey: QueryKey }
}

export type BootstrapSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof bootstrap>>>
export type BootstrapSuspenseQueryError = unknown

export const useBootstrapSuspense = <TData = Awaited<ReturnType<typeof bootstrap>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bootstrap>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBootstrapSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getBootstrapLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getBootstrapQueryKey(),
          queryFn: () => bootstrap(),
        }).then(() => null));
      /**
 * API endpoint used by frontend to check if token is valid and keep session alive.
 */
export const ping = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PingResponseData>(
      {url: `/frontend/ping`, method: 'GET', signal
    },
      options);
    }
  

export const getPingQueryKey = () => {
    return [`/frontend/ping`] as const;
    }

    
export const getPingQueryOptions = <TData = Awaited<ReturnType<typeof ping>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ping>>> = ({ signal }) => ping(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData> & { queryKey: QueryKey }
}

export type PingQueryResult = NonNullable<Awaited<ReturnType<typeof ping>>>
export type PingQueryError = unknown

export const usePing = <TData = Awaited<ReturnType<typeof ping>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ping>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ping>>> = ({ signal }) => ping(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData> & { queryKey: QueryKey }
}

export type PingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ping>>>
export type PingSuspenseQueryError = unknown

export const usePingSuspense = <TData = Awaited<ReturnType<typeof ping>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPingSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getPingLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getPingQueryKey(),
          queryFn: () => ping(),
        }).then(() => null));
      /**
 * Endpoint to add models/enums that are not part of any of our APIs but that we still want to expose to the frontend through the openapi schema.
 */
export const unusedModels = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<UnusedModelsData>(
      {url: `/frontend/unused-models`, method: 'GET', signal
    },
      options);
    }
  

export const getUnusedModelsQueryKey = () => {
    return [`/frontend/unused-models`] as const;
    }

    
export const getUnusedModelsQueryOptions = <TData = Awaited<ReturnType<typeof unusedModels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unusedModels>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnusedModelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof unusedModels>>> = ({ signal }) => unusedModels(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unusedModels>>, TError, TData> & { queryKey: QueryKey }
}

export type UnusedModelsQueryResult = NonNullable<Awaited<ReturnType<typeof unusedModels>>>
export type UnusedModelsQueryError = unknown

export const useUnusedModels = <TData = Awaited<ReturnType<typeof unusedModels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unusedModels>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUnusedModelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUnusedModelsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof unusedModels>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof unusedModels>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnusedModelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof unusedModels>>> = ({ signal }) => unusedModels(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof unusedModels>>, TError, TData> & { queryKey: QueryKey }
}

export type UnusedModelsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof unusedModels>>>
export type UnusedModelsSuspenseQueryError = unknown

export const useUnusedModelsSuspense = <TData = Awaited<ReturnType<typeof unusedModels>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof unusedModels>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUnusedModelsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUnusedModelsLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getUnusedModelsQueryKey(),
          queryFn: () => unusedModels(),
        }).then(() => null));
      